import { useAtomValue } from 'jotai';
import { relationshipLabelsAtom } from '../atoms/relationship-atoms';
export const useRelationshipsEnabled = (): boolean => {
  const hasRelationshipLabels = useAtomValue(relationshipLabelsAtom)?.length > 0;
  return hasRelationshipLabels;
};